import { Loader2 } from 'lucide-react';
import React from 'react';

import { cn } from '@/utils';

export const LoadingIndicator: React.FC<{ className?: string }> = ({
  className,
}): JSX.Element => (
  <Loader2 size={20} className={cn('animate-spin', className)} />
);
